import { useState } from 'react'
import { useSelector } from 'react-redux'
import IosVerfiyBasic from 'src/@core/components/modal/ios-verfiy-basic'
import IosVerfiyExtreme from 'src/@core/components/modal/ios-verfiy-extreme'
import IosBackup from 'src/@core/components/modal/ios-backup'
import {
  isAdvancedVerificationIncomplete,
  isBasicStepStillRequired,
  isResetTimePending
} from 'src/utils/iosIcloudBindStatus'
import { useRouter } from 'next/router'

const IosVerfiyProcess = () => {
  let Basic = window.localStorage.getItem('Basic')
  Basic = Basic == null || Basic == 0 ? true : false
  const router = useRouter()

  const store = useSelector(state => state.Common)
  const basicOver = [true, 'true'].includes(store.basicVerfiyOver) // 是否已完成一步验证
  const resetTimePending = isResetTimePending(store.resetTime) // 首屏数据未就绪时不判
  // 与 SpyX 对齐：看「高级验证是否触发过」(advancedDownloadTime)，而非「高级数据是否下载完成」
  const basicNotOver = isBasicStepStillRequired(store.resetTime)
  const advancedNotOver = isAdvancedVerificationIncomplete(store.resetTime)
  const downloadTips = [true, 'true'].includes(store.downloadTips) // 是否显示下载提示
  const [isModalOpen, setIsModalOpen] = useState(false) // 备份提示模态框显示状态

  return (
    <>
      {Basic && <IosVerfiyBasic />}
      {!resetTimePending && (basicOver || (!basicNotOver && advancedNotOver)) && (
        <IosVerfiyExtreme setBackupOpen={setIsModalOpen} />
      )}
      {downloadTips && <IosBackup isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />}
    </>
  )
}

export default IosVerfiyProcess